import { TriggerType, TriggerTypeConfig } from "@app2/clients/types/alert-typedefs";
import { localization } from "@app2/shared/localization/localization";

export const triggerTypes: TriggerTypeConfig[] = [
    {
        name: TriggerType.upperThreshold,
        localizationKey: "UPPER_THRESHOLD",
        description: localization.getString("UPPER_THRESHOLD_DESCRIPTION"),
        canEditQuery: true,
        canSetPrimaryField: true,
        canSetAggFn: true,
        canSetInterval: true,
        canSetThreshold: true,
        canSetWatchlists: true,
        canSetSavedQuery: true,
        selectable: true,
        suggestPredicate: () => true,
        warningPredicate: (avg, trigger) => {
            if (!trigger.intervalSeconds || !trigger.maxMatch) { return; }
            const intervalsPerDay = 24 * 60 * 60 / trigger.intervalSeconds;
            if (trigger.maxMatch * intervalsPerDay  < avg) {
                return "ALERT_TOO_FREQUENTLY";
            }
        },
    },
    {
        name: TriggerType.dynamicThresholds,
        localizationKey: "DYNAMIC_THRESHOLD",
        description: localization.getString("DYNAMIC_THRESHOLD_DESCRIPTION"),
        canEditQuery: true,
        canSetPrimaryField: true,
        canSetAggFn: true,
        canSetInterval: false,
        canSetThreshold: false,
        canSetWatchlists: true,
        canSetSavedQuery: true,
        selectable: true,
        suggestPredicate: (avg) =>  avg > 50,
        warningPredicate: (avg) => { if (avg <= 50) return "INSUFFICIENT_DATA_WARNING"; },
    },
    {
        name: TriggerType.lowerThreshold,
        localizationKey: "LOWER_THRESHOLD",
        description: localization.getString("LOWER_THRESHOLD_DESCRIPTION"),
        canEditQuery: true,
        canSetPrimaryField: false,
        canSetAggFn: true,
        canSetInterval: true,
        canSetThreshold: true,
        canSetWatchlists: true,
        canSetSavedQuery: true,
        selectable: true,
        suggestPredicate: (avg) =>  avg > 50,
        warningPredicate: (avg, trigger) => {
            if (!trigger.intervalSeconds || !trigger.minMatch) { return; }
            const intervalsPerDay = 24 * 60 * 60 / trigger.intervalSeconds;
            if (trigger.minMatch * intervalsPerDay > avg) {
                return "ALERT_TOO_FREQUENTLY";
            }
        },
    },
    {
        name: TriggerType.temporalAnomalyDetection,
        localizationKey: "TIME_BASED",
        description: localization.getString("TIME_BASED_DESCRIPTION"),
        canEditQuery: true,
        canSetPrimaryField: true,
        canSetAggFn: true,
        canSetInterval: false,
        canSetThreshold: false,
        canSetWatchlists: true,
        canSetSavedQuery: true,
        selectable: true,
        suggestPredicate: (avg) =>  avg > 50,
        warningPredicate: (avg) => { if (avg <= 50) return "INSUFFICIENT_DATA_WARNING"; },
    },
    {
        name: TriggerType.everyEvent,
        localizationKey: "EVERY_EVENT",
        description: localization.getString("EVERY_EVENT_DESCRIPTION"),
        canEditQuery: true,
        canSetPrimaryField: false,
        canSetAggFn: false,
        canSetInterval: false,
        canSetThreshold: false,
        canSetWatchlists: true,
        canSetSavedQuery: true,
        selectable: true,
        suggestPredicate: (avg) =>  avg < 5,
        warningPredicate: (avg) => { if (avg >= 2) return "ALERT_TOO_FREQUENTLY"; },
    },
    {
        name: TriggerType.sequence,
        localizationKey: "SEQUENCE_TRIGGER",
        description: localization.getString("SEQUENCE_TRIGGER_DESCRIPTION"),
        canEditQuery: true,
        canSetPrimaryField: false,
        canSetAggFn: false,
        canSetInterval: false,
        canSetThreshold: false,
        canSetWatchlists: false,
        canSetSavedQuery: false,
        selectable: true,
        suggestPredicate: () =>  false,
        warningPredicate: () => undefined,
    },
    {
        name: TriggerType.patternscoutSmartThreshold,
        localizationKey: "PATTERNSCOUT",
        description: localization.getString("PATTERNSCOUT_DESCRIPTION"),
        canEditQuery: false,
        canSetPrimaryField: false,
        canSetAggFn: false,
        canSetInterval: false,
        canSetThreshold: false,
        canSetWatchlists: false,
        canSetSavedQuery: true,
        selectable: false,
        suggestPredicate: () => false,
        warningPredicate: () => undefined,
    },
    {
        name: TriggerType.ueba,
        localizationKey: "UEBA",
        description: localization.getString("UEBA_DESCRIPTION"),
        canEditQuery: false,
        canSetPrimaryField: false,
        canSetAggFn: false,
        canSetInterval: false,
        canSetThreshold: false,
        canSetWatchlists: false,
        canSetSavedQuery: false,
        selectable: false,
        suggestPredicate: () => false,
        warningPredicate: () => undefined,
    },
    {
        name: TriggerType.fraudUba,
        localizationKey: "UBA_TITLE",
        description: localization.getString("UBA_DESCRIPTION"),
        canEditQuery: false,
        canSetPrimaryField: false,
        canSetAggFn: false,
        canSetInterval: false,
        canSetThreshold: false,
        canSetWatchlists: false,
        canSetSavedQuery: false,
        selectable: false,
        suggestPredicate: () => false,
        warningPredicate: () => undefined,
    },
    {
        name: TriggerType.threat,
        localizationKey: "THREATMATCH_TITLE",
        description: "",
        canEditQuery: false,
        canSetPrimaryField: false,
        canSetAggFn: false,
        canSetInterval: false,
        canSetThreshold: false,
        canSetWatchlists: false,
        canSetSavedQuery: false,
        selectable: false,
        suggestPredicate: () => false,
        warningPredicate: () => undefined,
    },
];

export const selectableTriggerTypes = triggerTypes.filter(typeConfig => typeConfig.selectable);
export const databaseTriggerTypeEnumTypes = [
    TriggerType.custom,
    TriggerType.sequence,
    TriggerType.threat,
    TriggerType.patternscoutSmartThreshold,
    TriggerType.ueba,
    TriggerType.fraudUba,
];
